<template>
  <div>
    <ul>
      <li class="text-sm font-bold">
        <a href="#" @click="selectAll" class="block py-3 text-center">全部</a>
      </li>
      <li v-for="catalog in catalogs" :key="catalog.no">
        <p
          class="text-center text-sm py-3 bg-gradient-to-br to-primary from-secondary from-5% bg-primary font-bold text-white"
        >
          {{ catalog.name }}
        </p>
        <ul>
          <NavigationItem
            v-for="category in catalog.children"
            :key="category.no"
            :category="category"
          />
        </ul>
      </li>
    </ul>
    <div class="h-40"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavigationItem from "@/components/product/NavigationItem";
export default {
  components: {
    NavigationItem,
  },
  computed: {
    ...mapGetters({
      navs: "app/navs",
      catalogs: "app/catalogs",
    }),
  },
  methods: {
    selectAll() {
      this.mapQuery({
        category: "",
        title: "全部",
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
